import { Link } from 'react-router-dom';
import { COLLECTIONS } from '@/data/shop-collections';
import { v3 } from '@/hooks/useTilt';

/**
 * Homepage "buy through the lab" (rewritten 2026-10-10, owner: make buying
 * computers and peripherals prominent). Collections as picture tiles, three
 * steps, and the way in. Still no prices on the site: the visitor sends a
 * list on WhatsApp and gets a quote (src/stores/quoteList.ts). Only facts the
 * site already states: order reaches the lab in 1–3 business days, advice first;
 * since 2026-10-27 UPS shipping nationwide (free over ₪2,000) or pickup in Natur.
 */
const STEPS = [
  { title: 'בוחרים', text: 'מסתכלים בקטלוג ומוסיפים לרשימת הבקשה, או פשוט כותבים מה צריך.' },
  { title: 'מקבלים הצעת מחיר', text: 'שולחים את הרשימה בוואטסאפ, ובניהו חוזר עם הצעת מחיר. לא בטוחים מה מתאים? שואלים קודם, בלי התחייבות.' },
  { title: 'משלוח או איסוף', text: 'משלוח עם UPS לכל הארץ, חינם בהזמנה מעל ₪2,000. אפשר גם לאסוף מהמעבדה בנטור: ההזמנה מגיעה אליה תוך 1–3 ימי עסקים.' },
];

const ProductsShowcase = () => {
  const tiles = COLLECTIONS.slice(0, 6);
  return (
    <section id="catalog" className="font-heebo cin-wash-pink py-[clamp(64px,8vw,120px)] px-[clamp(20px,5vw,80px)]">
      <div className="mx-auto max-w-[1280px]">
        <div className="cin-reveal mb-10 grid items-end gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="cin-label-ed mb-6">קונים דרך המעבדה</div>
            <h2 className="cin-display-sm text-[var(--cin-ink)]">
              מחשבים וציוד היקפי,
              <br />
              <span className="cin-text-gradient-pink">עם עצה לפני שקונים.</span>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-[var(--cin-muted)] lg:col-span-5">
            מחשבים ניידים ושולחניים, מסכים, ציוד היקפי, רשת ואחסון: מאות דגמים עם מפרט מלא. שולחים רשימה, מקבלים
            הצעת מחיר, ומי שעונה לכם הוא מי שגם מתקן.
          </p>
        </div>

        <ul className="mb-12 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
          {tiles.map((c, i) => {
            const img = v3(c.image);
            return (
              <li key={c.slug} className={`cin-reveal cin-reveal-d${(i % 3) + 1}`}>
                <Link to={`/shop/${c.slug}`} className="group relative block aspect-[4/3] overflow-hidden rounded-2xl border border-[var(--cin-line)] cin-tilt">
                  <img
                    src={img.src}
                    srcSet={img.srcSet}
                    sizes="(min-width: 768px) 400px, 50vw"
                    alt=""
                    width={800}
                    height={600}
                    loading="lazy"
                    decoding="async"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:scale-105"
                  />
                  <span className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" aria-hidden="true" />
                  <span className="absolute inset-x-0 bottom-0 p-4 md:p-5 text-white">
                    <span className="block text-base font-bold leading-tight md:text-xl">{c.title}</span>
                    <span className="mt-0.5 hidden text-sm text-white/85 sm:block">{c.short}</span>
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>

        <ol className="mb-10 grid gap-4 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <li key={s.title} className="flex gap-4 rounded-2xl border border-[var(--cin-line)] bg-white p-5">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--cin-ink)] font-bold text-white" aria-hidden="true">
                {i + 1}
              </span>
              <span>
                <span className="block font-bold text-[var(--cin-ink)]">{s.title}</span>
                <span className="mt-1 block text-[15px] leading-relaxed text-[var(--cin-muted)]">{s.text}</span>
              </span>
            </li>
          ))}
        </ol>

        <div className="flex flex-wrap items-center gap-4">
          <Link to="/shop" className="cin-btn-primary cin-magnetic">
            לכל הקטלוג ←
          </Link>
          <a
            href={`https://wa.me/972546672863?text=${encodeURIComponent('היי בניהו, אני מחפש/ת מחשב או ציוד, ואשמח לעזרה בבחירה: ')}`}
            target="_blank"
            rel="noopener noreferrer"
            data-track-from="home-shop"
            className="cin-btn-ghost"
          >
            לא בטוחים? עזרה בבחירה בוואטסאפ
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductsShowcase;
